import { useTranslate } from "@similarweb/i18n-provider";
import { Check } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { featureInfo, type FeatureArea } from "app/components/PackageSwitcher/consts/packageFeatureInfo";

import { Block, FeatureItem, FeatureList, PackageFeatureInfoHolder } from "./PackageFeatureInfo.styled";

interface IPackageFeatureInfoProps {
    featureArea: FeatureArea;
}

export const PackageFeatureInfo = ({ featureArea }: IPackageFeatureInfoProps) => {
    const { translate } = useTranslate();
    const features = featureInfo[featureArea];

    return (
        <PackageFeatureInfoHolder>
            <Block>
                <Text
                    fontVariant="captionTitle"
                    color={colorsPalettes.carbon[400]}
                >
                    {translate("buyer_journey.switch_package.feature_info.title")}
                </Text>
                <FeatureList>
                    {features.map((featureKey) => (
                        <FeatureItem key={featureKey}>
                            <Check
                                size="xs"
                                color={colorsPalettes.green["400_P"]}
                            />
                            <Text
                                fontVariant="caption"
                                color={colorsPalettes.carbon[400]}
                            >
                                {translate(featureKey)}
                            </Text>
                        </FeatureItem>
                    ))}
                </FeatureList>
            </Block>
        </PackageFeatureInfoHolder>
    );
};
